<template>
  <div class="mm-page-main" v-loading="loading">
    <div class="page-header">
      <div class="page-title">修改匯率</div>
      <div @click="pageback" class="page-back">
        <svg class="icon svg-icon" aria-hidden="true">
          <use xlink:href="#icon-back"></use>
        </svg>
      </div>
    </div>
    <div class="pagemain">
      <el-form ref="form" :model="form" label-width="80px" label-position="left">
        <div class="form-group">
          <div class="form-group-content">
            <div class="mm-row-block">
              <div class="mm-row">
                <div class="mm-col">
                  <el-form-item label="門店">
                    <div>{{row.storename||'總店'}}</div>
                  </el-form-item>
                </div>
              </div>
              <div class="mm-row">
                <div class="mm-col">
                  <el-form-item label="類型">
                    <div style="display: flex; align-items: center;">
                      <div v-if="row.type0 == 0 ">現金</div>
                      <div v-if="row.type0 == 1 ">電匯</div>
                    </div>
                  </el-form-item>
                </div>
              </div>
              <div class="mm-row">
                <div class="mm-col">
                  <el-form-item label="幣種">
                    <div style="display: flex; align-items: center;">
                      <div><img style="width: 30px; height: 30px; display: block;" :src="apiurl+row.thumb"></div>
                      <div style="margin-left: 10px;">{{row.name}}</div>
                    </div>
                  </el-form-item>
                </div>
              </div>
              <div class="mm-row">
                <div class="mm-col">
                  <el-form-item label="買入匯率">
                    <el-input v-model="form.buyrate"></el-input>
                  </el-form-item>
                </div>
              </div>
              <div class="mm-row">
                <div class="mm-col">
                  <el-form-item label="賣出匯率">
                    <el-input v-model="form.sellrate"></el-input>
                  </el-form-item>
                </div>
              </div>
              <div class="mm-row">
                <div class="mm-col">
                  <el-form-item label="成本匯率">
                    <el-input v-model="form.costrate"></el-input>
                  </el-form-item>
                </div>
              </div>
              <div class="mm-row">
                <div class="mm-col">
                  <el-form-item label="手續費">
                    <el-input v-model="form.fee"></el-input>
                  </el-form-item>
                </div>
              </div>
              <div class="mm-row">
                <div class="mm-col">
                  <el-form-item label="手續貨幣">
                    <el-radio-group v-model="form.fee_type" size="medium">
                      <el-radio-button label="1">HKD</el-radio-button>
                      <el-radio-button label="0">{{row.name}}</el-radio-button>
                    </el-radio-group>
                  </el-form-item>
                </div>
              </div>

            </div>

          </div>
        </div>

        <div class="form-submit">
          <el-button @click="formsubmit('form')" type="primary">提交</el-button>
        </div>
      </el-form>
    </div>
  </div>
</template>

<script>
export default {

  data () {
    return {
      loading: false,
      row: {},
      form: {

      },

    };
  },
  methods: {
    pageback () {
      this.$router.go(-1);
    },
    formsubmit (form) {
      this.loading = true;
      let data = this.form;
      this.post('/api/rate/editratesave', {
        data: data
      }).then((res) => {
        this.loading = false;

        if (res == 'success') {
          this.$message({
            showClose: true,
            message: '修改匯率成功！',
            type: 'success',
            onClose: (() => {
            })
          });
          this.pageback();
        } else {
          this.$message({
            showClose: true,
            message: '修改匯率失敗，請重試！',
            type: 'error',
          });
        }


      }).catch((err) => {
        this.loading = false;
        console.log(err)
      });
    },
    geteditdata () {
      let form = {};
      let row = this.$route.params.row;
      form.store_id = row.store_id;
      form.currency_id = row.currency_id;
      form.type0 = row.type0;
      form.buyrate = row.buyrate;
      form.sellrate = row.sellrate;
      form.costrate = row.costrate;
      form.fee = row.fee;
			form.fee_type = row.fee_type;
      this.row = row;
      this.form = form;

    },
  },
  created () {

    this.geteditdata();
  }

};
</script>
<style scoped>
.mm-row {
  width: 50%;
}
</style>
